import { Button, Close } from '@bphxd/ds-core-react';
import { FC, useState } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Form, FormGroup, Label, Input } from 'reactstrap';
import classes from '../JobFiltersModal/JobFiltersModal.module.scss';
import { EMPTY_LEAK_TEST_PACK_FILTERS } from '../../../lib/constants';
import Select from 'react-select';
import { ReactSelectOverrides } from '@bphxd/ds-core-react';
import { optionsFromEnum, stringToOption } from '../../../lib/util/format';
import {
  LEAK_TEST_PACK_TYPE_ENUM,
} from '../../../lib/constants/dbConstants';
import clsx from 'clsx';
import { Trash24 } from '@bphxd/ds-core-react/lib/icons';
import { TAspectsTableFilters } from '../AspectsTable/AspectsTable';
import {
  getEventOptions,
  getAugmentedOptionsFromMapping as getOptions,
} from '../JobFiltersModal/JobFiltersModal.util';
import { useSelectedAsset } from '../../../lib/util';
import { useQuery } from '@apollo/client';
import { GET_EVENTS_BY_ASSET } from '../../../graph-queries/tar/event';
import { TEvent } from '../../../lib/types';


export type TLeakTestPackFilters = TAspectsTableFilters<
  | 'leakTestPackType'
  | 'leakTestPackTitle'
  | 'trackPackNumber'
  | 'systemNumber'
  | 'event'
>;

const TLeakTestPackFiltersModal: FC<{
  defaultValues: TLeakTestPackFilters;
  onSubmit: (filters: TLeakTestPackFilters) => unknown;
  onClose: () => void;
}> = ({ defaultValues, onSubmit, onClose }) => {
  const [filters, setFilters] = useState<TLeakTestPackFilters>(defaultValues);

  const setFilterByKey = (key: keyof TLeakTestPackFilters, values: string[]) => {
    setFilters((filters) => ({ ...filters, [key]: values }));
  };
  const handleSubmit = () => {
    onSubmit(filters);
    onClose();
  };

  const handleDelete = () => {
    onSubmit(EMPTY_LEAK_TEST_PACK_FILTERS);
    onClose();
  };
  const asset = useSelectedAsset();
  const { data, loading } = useQuery(GET_EVENTS_BY_ASSET, {
    variables: { assetId: asset?.assetId || -1 },
    skip: !asset?.assetId,
  });
  const events = data?.eventsByAssetId as TEvent[];

  return (
    <Modal isOpen toggle={onClose} className="modal-dialog-centered">
      <ModalHeader className="border-0 px-6" close={<Close onClick={onClose} />}>
        Filter Leak Test Packs
      </ModalHeader>
      <ModalBody className={clsx('p-6 pt-0', classes.root)}>
        <div className={classes.filters}>
          <Form className="row g-5">
            {/* <div className="col-md-6">MO Status</div> */}
            <div className="col-md-6">
              <FormGroup>
                <Label>Event</Label>
                <Select
                  defaultValue={filters.event.map(stringToOption)}
                  isMulti
                  options={getEventOptions(asset, events).map(stringToOption)}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={false}
                  components={ReactSelectOverrides.default}
                  classNamePrefix="react-select"
                  onChange={(newSelection) => {
                    setFilterByKey(
                      'event',
                      newSelection.map((o) => o.value)
                    );
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Type</Label>
                <Select
                  defaultValue={filters.leakTestPackType.map(stringToOption)}
                  isMulti
                  options={optionsFromEnum(LEAK_TEST_PACK_TYPE_ENUM)}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={false}
                  components={ReactSelectOverrides.default}
                  classNamePrefix="react-select"
                  onChange={(newSelection) => {
                    setFilterByKey(
                      'leakTestPackType',
                      newSelection.map((o) => o.value)
                    );
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Title</Label>
                <Input
                  type="text"
                  title="Use comma to separate multiple values like 'Compressor, PBE-211'."
                  name="leakTestPackTitle"
                  id="leak-test-pack-title"
                  defaultValue={filters.leakTestPackTitle}
                  onChange={(e) => {
                    const titleArrary: string[] = e.target.value.split(',');
                    setFilterByKey('leakTestPackTitle', titleArrary);
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Pack Number</Label>
                <Input
                  type="text"
                  title="Use comma to separate multiple values like 'A123,B456'. Values need to be exact."
                  name="trackPackNumber"
                  id="track-pack-number"
                  defaultValue={filters.trackPackNumber}
                  onChange={(e) => {
                    const trackPackNumberArrary: string[] = e.target.value.split(',');
                    setFilterByKey('trackPackNumber', trackPackNumberArrary);
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>System Number</Label>
                <Input
                  type="text"
                  title="Use comma to separate multiple values like 'A123,B456'. Values need to be exact."
                  name="systemNumber"
                  id="system-number"
                  defaultValue={filters.systemNumber}
                  onChange={(e) => {
                    const systemNumberArrary: string[] = e.target.value.split(',');
                    setFilterByKey('systemNumber', systemNumberArrary);
                  }}
                />
              </FormGroup>
            </div>
            {/* Footer */}
            <div className={clsx('col-md-12', classes.footer)}>
              <Button
                size="lg"
                className=""
                theme="darker"
                level="tertiary"
                onClick={handleDelete}
                Icon={Trash24}
              >
                Remove Filters
              </Button>
              <Button
                disabled={filters === defaultValues}
                size="md"
                className=""
                theme="darker"
                level="primary"
                onClick={handleSubmit}
              >
                Apply Filters
              </Button>
            </div>
          </Form>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default TLeakTestPackFiltersModal;
